import { defineMessages } from "react-intl";

export const messages = defineMessages({
  dropzoneHint: {
    id: "F1j+kx",
    defaultMessage: "Drag & drop images here, or click to browse",
    description: "image upload dropzone hint",
  },
  uploading: {
    id: "p3qZqK",
    defaultMessage: "Uploading…",
    description: "image upload in progress",
  },
  uploadProgress: {
    id: "CCmQ7o",
    defaultMessage: "Uploading images: {completed} of {total}",
  },
  uploadedMatched: {
    id: "3QZFBq",
    defaultMessage: "Uploaded · catalog match found",
  },
  uploadedUnmatched: {
    id: "EN+3aD",
    defaultMessage: "Uploaded · no catalog match",
  },
  notUploaded: {
    id: "W93C+Q",
    defaultMessage: "Not uploaded",
  },
  stagedNote: {
    id: "nIoOUl",
    defaultMessage:
      "Uploads are staged in the import folder. Scan the folder and import the Images sheet to attach them to products or variants.",
  },
  uploadSummary: {
    id: "msKC27",
    defaultMessage:
      "{saved} uploaded; {matched} matched; {unmatched} need review; {failed} failed.",
  },
  uploadReviewTitle: {
    id: "t4ZutM",
    defaultMessage: "Images uploaded; some need review",
  },
  uploadDone: {
    id: "aqSzb6",
    defaultMessage: "Uploaded {count} image(s) to the import folder",
    description: "image upload success",
  },
  uploadFailed: {
    id: "GY5v1m",
    defaultMessage: "Image upload failed",
    description: "image upload error title",
  },
});
